import { fetch, getStorageKey, getUrlParam, setStorageFormSetting, Storage } from 'scripts/utils'
import { PublishedCampaignForm } from 'scripts/constants'
import { CampaignType, PublishedEntryMode } from 'scripts/type'
import { setPageTitle } from 'scripts/utils/setPageTitle'

const preloadUrlMode = 'preload'
const previewUrlMode = 'preview'
const URL_USER_DATA_PREFIX = 'x_user_'

type Params = {
  campaignToken: string
  cusd?: string
  mode?: PublishedEntryMode
  shouldUpdateFormSetting?: boolean
  type?: CampaignType
  isUrlVisit?: boolean
}

export default function queryCampaignFields(params: Params): Promise<any> {
  const { campaignToken, cusd, mode, shouldUpdateFormSetting = true, type, isUrlVisit = false } = params
  return new Promise((resolve, reject) => {
    const urlMode = getUrlParam('mode')
    const finalMode =
      mode ??
      (urlMode === preloadUrlMode || urlMode === previewUrlMode
        ? PublishedEntryMode.PREVIEW
        : PublishedEntryMode.NORMAL)
    const variables = {
      campaignId: campaignToken,
      customerUid: getUrlParam(`${URL_USER_DATA_PREFIX}uid`),
      cusd: cusd || getUrlParam('cusd'),
      mode: finalMode,
      skipEntryId: finalMode === PublishedEntryMode.PREVIEW && urlMode === preloadUrlMode,
      isUrlVisit,
    }

    fetch({
      input: { query: PublishedCampaignForm, variables },
      successCallback: ({ data }) => {
        const { nextFields, publishedEntryId, token, setting } = data.campaignForm
        setPageTitle(nextFields, setting.localeSetting.locale, type)
        resolve(nextFields)
        publishedEntryId && storeSdkEntryId(publishedEntryId, campaignToken)
        if (shouldUpdateFormSetting) {
          setStorageFormSetting(setting, campaignToken)
        }
        Storage.setItem(getStorageKey('publishedFormToken', campaignToken), token)
      },
      errorCallback: (data) => {
        return reject(data)
      },
    })
  })
}

function storeSdkEntryId(sdkEntryId: string, token: string) {
  Storage.setItem(getStorageKey('publishedEntryId', token), sdkEntryId)
}
